import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthHttpConfig } from "./auth-http-config";

export const impersonateInterceptor: HttpInterceptorFn = (request, next) => {
  const httpConfig = inject(AuthHttpConfig);

  if (httpConfig.getImpersonatedUsername()) {
    request = request.clone({
      setHeaders: {
        "X-Switch-User": `${httpConfig.getImpersonatedUsername()}`,
      },
    });
  }

  return next(request);
};
